module.exports = __webpack_public_path__ + "static/media/github.94c73a67.svg";